import React from 'react';

interface FileIndicatorProps {
  hasFile?: boolean;
}

export const FileIndicator: React.FC<FileIndicatorProps> = ({ hasFile }) => {
  if (hasFile === undefined || hasFile === null) return null;

  return (
    <span
      title={hasFile ? 'Has file' : 'No file'}
      style={{
        display: 'inline-block',
        width: 5,
        height: 5,
        borderRadius: '50%',
        backgroundColor: hasFile ? 'rgba(34, 197, 94, 0.5)' : 'rgba(239, 68, 68, 0.35)',
        marginRight: 5,
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    />
  );
};
